import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Slider from '@material-ui/core/Slider';

const useStyles = makeStyles({
  root: {
    width: 500,
  },
});

// const valuetext = (value) => {
//   return `${value}°C`;
// }

export default function DecimationSlider({setDecimation}) {
  const classes = useStyles();
  
  const updatePreset = (e, value) => {
    setDecimation(value)
  }
  return (
    <div className={classes.root}>
      <Slider
        defaultValue={2}
        onChange={updatePreset}
        // getAriaValueText={valuetext}
        step={1}
        marks
        min={0}
        max={4}
        valueLabelDisplay={"off"}
      />
    </div>
  );
}